;import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import * as ElementPlusIconVue from '@element-plus/icons-vue'
import router from './router'
import store from './store'
import '@/assets/scss/index.scss';
import  axios from '@/assets/utils/axios'
import  commons from '@/assets/utils/commons'


import vue3VideoPlay from 'vue3-video-play'
import 'vue3-video-play/dist/style.css'
const  app = createApp(App);
app.config.globalProperties.ajax = axios
app.config.globalProperties.router = router;

//添加element ui字体
for ( const [key ,component] of Object.entries(ElementPlusIconVue)) {
    app.component(key,component)
}

app.use(store).use(router).use(ElementPlus, {locale: zhCn}).use(vue3VideoPlay).use(commons).mount('#app');

//
// router.beforeEach((to, from, next) => {
//     console.log(to,from, next);
//     // next(new Error())
//     // // or
//     // throw new Error()
//     // // or
//     // return Promise.reject(new Error())
// })

